module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AlterPasswordView.js"));
	}, "AlterPasswordView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AlterPasswordView!./src/pages/Store/Password/AlterPassword/AlterPasswordView.js
// module id = 1201
// module chunks = 431